<main class="-mt-24 pb-8">
  <div class="max-w-9xl mx-auto px-4 sm:px-6 lg:max-w-9xl lg:px-8">

    <!-- Main 3 column grid -->
    <div class="grid">
      <!-- Left column -->
      <div class="grid grid-cols-1 gap-4 lg:col-span-2">
        <!-- Welcome panel -->
        <section>
          <div class="rounded-lg bg-white overflow-hidden shadow">
            <div class="min-h-fit sm:items-center sm:justify-between">
              <div class="h-full p-6 w-full bg-white">
                <div class="text-center">
                  <svg xmlns="http://www.w3.org/2000/svg" class="mx-auto h-12 w-12 text-gray-400" fill="none"
                    viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path vector-effect="non-scaling-stroke" stroke-linecap="round" stroke-linejoin="round"
                      stroke-width="2"
                      d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                  </svg>
                  <h3 class="mt-2 text-xl font-medium font-bold text-gray-900">Request New Consult</h3>
                  <p class="mt-1 text-sm text-gray-500">What type of consult is this?</p>


                  <div class="max-w-md mx-auto sm:max-w-3xl">
                    <div class="mt-10">
                      <ul role="list" class="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 ul-list">
                        <li *ngFor="let program of hospitalPrograms">
                          <button type="button" (click)="openHospitalProgramConsultForm(program.id)"
                            [ngClass]="program.isConsultUrgentAttention == true ? 'bg-red-50 hover:bg-red-100 focus:ring-red-500' : 'hover:bg-gray-50 focus:ring-indigo-500'"
                            class="group p-2 w-full flex items-center justify-between rounded-full border border-gray-300 shadow-sm space-x-3 text-left  focus:outline-none focus:ring-2 focus:ring-offset-2">
                            <span class="pl-4 min-w-0 flex-1 flex items-center space-x-3">
                              <span class="block min-w-0 flex-1">
                                <span [ngClass]="program.isConsultUrgentAttention == true ? 'text-red-700' : ''"
                                  class="block text-xl font-bold font-medium text-gray-900 truncate">{{
                                  program.programName }}</span>
                                <span [ngClass]="program.isConsultUrgentAttention == true ? 'text-red-700' : ''"
                                  class="block text-sm font-medium text-gray-500 truncate">Turnaround time: {{
                                  program.signOffTimeFrame
                                  }} minutes</span>
                              </span>
                            </span>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</main>
